<template>
    <rkm-modal
        :loading="loading"
        title="Busca de CID"
        large
        ref="Modal"
        hide-footer
    >
        <List
            :procedimento-id="procedimentoId"
            :principal="principal"
            @select="handleSelect"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        procedimentoId: null,
        principal: null,
    }),
    methods: {
        open(params = {}) {

            if ('procedimentoId' in params) {

                this.procedimentoId = params.procedimentoId
            }

            if ('principal' in params) {

                this.principal = params.principal
            }

            this.$refs.Modal.show()
        },
        handleSelect(cid) {

            this.$emit('select', cid)

            this.$refs.Modal.hide()
        },
    }
}
</script>